import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    active: {
      color: theme.palette.primary.main,
    },

    name: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 500,
      color: theme.palette.text.primary,
    },

    textRight: {
      textAlign: 'right',
    },

    mt10: {
      marginTop: 10,
    },

    mt5: {
      marginTop: 5,
    },

    cardContentPadding: {
      padding: '24px 24px;',
    },

    subscriptionListItem: {
      width: '100%',
      padding: '0 4px 8px 0',
      textAlign: 'left',
      '&:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.palette.common.greyLight}`,
      },
    },

    timezone: {
      color: theme.palette.secondary.light,
      fontSize: theme.typography.pxToRem(13),
      opacity: 0.8,
    },
    documentIconLabel: {
      '& svg': {
        fontSize: theme.typography.pxToRem(14),
        fill: theme.palette.form.labelFilledColor,
      },
    },
    documentIconRoot: {
      margin: '6px -25px 15px',
      borderRadius: '50% !important',
    },
  };
});

const listStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
      textAlign: 'right',
    },

    primary: {
      fontSize: 13,
      fontWeight: 500,
      color: '#4D4F5C',
      textAlign: 'left',
      wordBreak: 'break-word',
    },

    secondary: {
      fontSize: '13px',
      color: '#4D4F5C',
      fontWeight: 300,
      wordBreak: 'break-word',
      maxWidth: '60%',
    },
  };
});

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    primary: {
      fontSize: '13px',
      fontWeight: 'bold',
      color: '#4D4F5C',
      wordBreak: 'break-word',
    },

    secondary: {
      color: theme.palette.common.lightNavy,
      fontSize: '13px',
      wordBreak: 'break-word',
      paddingLeft: 8,
    },
  };
});

const customCardStyles = makeStyles((theme) => {
  return {
    root: {
      padding: 0,
      paddingBottom: '0 !important',
    },
  };
});

const collapseCardStyles = makeStyles({
  root: {
    marginTop: 20,
    marginBottom: 20,
    '& button': {
      borderRadius: '4px 4px 0 0',
    },
  },
  box: {
    marginTop: 0,
    borderTop: 0,
    borderRadius: '0 0 4px 4px',
  },
  buttonClass: {
    backgroundColor: '#FBFBFB',
    border: '1px solid #EEEEEE',
    boxShadow: 'none',
    color: '#4D4F5C',
    padding: '6px 24px',
    textTransform: 'capitalize',
    textAlign: 'left',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: '#FBFBFB',
      border: '1px solid #EEEEEE',
      boxShadow: 'none',
      color: '#4D4F5C',
    },
  },
});

export { useStyles, listStyles, listTextStyles, customCardStyles, collapseCardStyles };
